// import package
import React, { useEffect, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import SocketContext from '../../context/SocketContext';

// import action
import { viewUserProfile, logout, getSiteSetting } from '../../api/users';
import { getArbiProfit, getAssetData, getCurrency, getPriceConversion } from '../../api/walletAction';
import { unReadNotice, FetchunReadNotice } from '../../api/users';

// import lib
import isEmpty from '../../lib/isEmpty';

const AUTO_LOGOUT_TIME = 12 * 60 * 60 * 1000;
const AUTO_LOGOUT_EVENTS = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];

const HelperRoute = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const socketContext = useContext(SocketContext);
    const inactivityTimerRef = useRef(null);

    // redux-state
    const { isAuth } = useSelector(state => state.auth);
    const currencyOption = useSelector(state => state.currency)

    // function
    useEffect(() => {
        if (isAuth) {
            viewUserProfile(dispatch)
            getAssetData(dispatch)
            unReadNotice(dispatch)
            getArbiProfit(dispatch)
        }
    }, [isAuth])

    useEffect(() => {
        // if (!(currencyOption && currencyOption.length > 0)) {
        getCurrency(dispatch);
        // }
        getPriceConversion(dispatch);
        getSiteSetting(dispatch)
    }, []);
    useEffect(() => {
        if (!isAuth) {
            return undefined;
        }

        const resetAutoLogoutTimer = () => {
            console.log("resetAutoLogoutTimer",inactivityTimerRef.current);
            if (inactivityTimerRef.current) {
                clearTimeout(inactivityTimerRef.current);
            }

            inactivityTimerRef.current = setTimeout(() => {
                logout(navigate, dispatch, t, "auto_logout");
            }, AUTO_LOGOUT_TIME);
        }

        AUTO_LOGOUT_EVENTS.forEach((eventName) => {
            window.addEventListener(eventName, resetAutoLogoutTimer);
        });
        resetAutoLogoutTimer();

        return () => {
            if (inactivityTimerRef.current) {
                clearTimeout(inactivityTimerRef.current);
            }

            AUTO_LOGOUT_EVENTS.forEach((eventName) => {
                window.removeEventListener(eventName, resetAutoLogoutTimer);
            });
        }
    }, [isAuth, navigate, dispatch, t]);

    useEffect(() => {

        socketContext.socket.on('notice', (result) => {
            FetchunReadNotice(dispatch, result)
        })

        // socketContext.socket.on('NEW_DEPOSIT', (result) => {
        //     getAssetData(dispatch)
        // })

        // socketContext.socket.on('FORCE_LOGOUT', (result) => {
        //     let token = localStorage.getItem('user_token');
        //     if (!isEmpty(token) && !isEmpty(result) && token != result) {
        //         logout(navigate, dispatch)
        //     }
        // })


    }, [])

    return <div />
}

export default HelperRoute;